import styled from "styled-components/macro"
import { Wrapper } from "./elements"

export default styled.main`
  min-height: ${window.innerHeight}px;
  background-color: #fff;
`

export const MainHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  height: 60px;
`

export const MainHeader = styled.section`
  width: 100%;
  position: relative;
  color: #fff;
  padding-top: ${props => props.theme.header.height};
  background: ${props =>
    props.backgroundImage ?
      `url(${props.backgroundImage})`
      :
      'none'} 
    center center / cover no-repeat;
  padding-bottom: 20px;
  border-radius: 0 0 10px 10px;
  height: 220px;

  & dom {
    display: block;
    height: 10px;
  }
`

export const MainHeaderBottom = styled.section`
  padding: ${props => props.theme.padding};
  width: 100%;
  /* margin-top: -15px; */
`

export const HomeBody = styled.section`
  margin-top: -30px;
`

export const CurrentPosition = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  width: 57%;
`

export const Stars = styled.div`
  display: flex;
  cursor: pointer;
`

export const Ads = styled(Wrapper)`
  padding: 0 ${props => props.theme.padding};
`

export const TiersBtn = styled.div`
  display: flex;
  cursor: pointer;
  font-size: 12px;
`